import { setupRecurrenceRulesFormButtons } from '../../lib/form_helpers';

const AdministrationFareAdapterConfigurations = {
  init() {
    setupRecurrenceRulesFormButtons();
  }
};

export default AdministrationFareAdapterConfigurations;
